import type {VersionInfo} from './app/utils.class';

export const compiledVersion: VersionInfo = {"buildNumber":"D. van der Steen B.V_acceptance_2026-11-04_15-0-3","buildId":"24903","environment":"dvds-acceptance","datetime":"2026-11-04T14:02:27.960Z","checkForUpdates":true}